import { useEffect, useMemo, useState } from 'react';

import { requestCarVariantColors } from '^api/carVariants';
import ApplicationConfig from '^services/ApplicationConfig';
import ICarColor from '^types/ICarColor';
import logger from '^utils/logger';

interface IUseCarVariantColorsResponse {
  list: ICarColor[];
  hasError: boolean;
  areLoading: boolean;
}

const useCarVariantColors = (): IUseCarVariantColorsResponse => {
  const [areLoading, setAreLoading] = useState<boolean>(false);
  const [list, setList] = useState<ICarColor[]>([]);
  const [hasError, setError] = useState<boolean>(false);

  useEffect(
    (): void => {
      const getCarVariantColors = async (): Promise<void> => {
        setAreLoading(true);

        try {
          const { data: { list } } = await requestCarVariantColors(ApplicationConfig.variantCode);
          setList(list);
        } catch (error) {
          logger.trackError(error as Error, {
            catcher: 'useCarVariantColors',
          });
          setError(true);
        } finally {
          setAreLoading(false);
        }
      };

      void getCarVariantColors();
    },
    [],
  );

  return useMemo(
    (): IUseCarVariantColorsResponse => ({
      list,
      areLoading,
      hasError,
    }),
    [areLoading, hasError, list],
  );
};

export default useCarVariantColors;
